export class PodObservation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "component",
            "baseName": "component",
            "type": "string",
            "format": ""
        },
        {
            "name": "phase",
            "baseName": "phase",
            "type": "string",
            "format": ""
        },
        {
            "name": "ready",
            "baseName": "ready",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "restartCount",
            "baseName": "restartCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastTerminationReason",
            "baseName": "lastTerminationReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastTerminationMessage",
            "baseName": "lastTerminationMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PodObservation.attributeTypeMap;
    }
    constructor() {
    }
}
